import HeroImage from "../../components/heros/hero-image";
import CoverIntro from "../../assets/images/cover-intro.jpeg";
import WhyUs from "../../assets/images/why-us.jpeg";

import OurServices from "./components/our-services/our-services";
import ChooseUs from "./components/choose-us/choose-us";
import Goals from "./components/goals/goals";
import HomeNewProject from "./components/new-project/home-new-project";
import HomeHeroPreload from "./components/home-hero-preload/home-hero-preload";
import { useBreakpoint } from "../../hooks/useBreakpoint";
import { HOME_INTRO_VIDEOS } from "../../constants/media";
import { MAILTO_COMMERCIAL, TEL_SEGRETERIA } from "../../constants/contacts";

import "./homePage.scss";

const HomePage: React.FC = () => {
  const device = useBreakpoint();
  const isMobile = device === "mobile";
  return (
    <div className="home">
      <HomeHeroPreload posterSrc={CoverIntro} />
      <HeroImage
        title="Tecnologie Speciali per il Consolidamento"
        text="Tecnologie avanzate per consolidamento, mediante soluzioni non invasive e precise."
        img={CoverIntro}
        altImg="Pali rotoinfissi e consolidamento fondazioni - cantiere Rotoinfissioni"
        isMobile={isMobile}
        video={HOME_INTRO_VIDEOS.desktop}
        mobileVideo={HOME_INTRO_VIDEOS.mobile}
        btnLeftText="Chiamaci ora"
        btnLeftIconName="phone"
        btnRightText="Invia Email"
        btnRightIconName="envelope"
        btnLeftHref={TEL_SEGRETERIA}
        btnRightHref={MAILTO_COMMERCIAL}
      />
      <OurServices
        title="I Nostri Servizi"
        text="Esecuzioni e tecniche avanzate per fondazioni e consolidamenti"
      />
      <ChooseUs
        title="Perché Scegliere Rotoinfissioni"
        img={WhyUs}
        isMobile={isMobile}
        altImg="Operai Rotoinfissioni in cantiere durante un intervento di consolidamento"
      />
      <Goals />
      <HomeNewProject isMobile={isMobile} />
    </div>
  );
};
export default HomePage;
